module.exports = __webpack_public_path__ + "static/img/wb.a3b4bac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wb.png
// module id = 3KCY
// module chunks = 26